import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { PagesService } from 'src/app/core/_services/pages/pages.service';

@Component({
  selector: 'app-manage-sub-confirm-dialog',
  templateUrl: './manage-sub-confirm-dialog.component.html',
  styleUrls: ['./manage-sub-confirm-dialog.component.scss']
})
export class ManageSubConfirmDialogComponent implements OnInit {

  priceBreakdown = {
    packagePrice: 0,
    trucksPrice: 0,
    addonsPrice: 0,
    total: 0
  };

  chargedAddOns: { label: string; price: number }[] = [];
  proRatedAmounts: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: PagesService,
    private loader: NgxUiLoaderService,
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<ManageSubConfirmDialogComponent>
  ) { }

  ngOnInit(): void {
    this.getProRatedAmounts();
  }

  getProRatedAmounts(): void {
    this.loader.start();
    const payload = {
      packageId: this.data.packageDetail._id,
      subscriptionId: this.data.subscriptionId,
      numberOfTrucks: this.data.packageNotChanged ? this.abs(this.data.numberOfTrucks, this.data.originalNumberOfTrucks) : this.data.numberOfTrucks,
      addOns: this.data.addOns
    };

    this.service.post(payload, API_ROUTES.PACKAGES.proRatedPackage).subscribe({
      next: (res) => {
        if (!res?.status || !res?.data) {
          this.toastr.error('Failed to fetch prorated amount');
          return;
        }

        this.proRatedAmounts = res.data;
        this.calculate();
      },
      error: (err) => {
        this.loader.stop();
        this.toastr.error(err?.msg || 'Something went wrong');
      },
      complete: () => this.loader.stop()
    });
  }

  calculate(): void {
    this.chargedAddOns = [];

    const pkg = this.data.packageDetail;
    const newAddOns = this.data.addOns;
    const oldAddOns = this.data.originalAddOns;
    const packageNotChanged = this.data.packageNotChanged;

    let packagePrice = packageNotChanged ? 0 : Number(pkg.pricing.packagePrice) || 0;
    let addonsPrice = 0;

    const trucksPrice = Number(this.proRatedAmounts?.proratedCost?.trucks) || 0;
    const addOnPrices = this.proRatedAmounts?.proratedCost?.addOns || {};

    const pushAddon = (key: string, label: string) => {
      const price = Number(addOnPrices[key]) || 0;
      addonsPrice += price;
      this.chargedAddOns.push({ label, price });
    };

    if (packageNotChanged) {
      if (newAddOns.aiRouting && !oldAddOns.aiRouting.enabled) {
        pushAddon('aiRouting', 'AI Routing');
      }
      if (newAddOns.emailMarketing && !oldAddOns.emailMarketing.enabled) {
        pushAddon('emailMarketing', 'Email Marketing');
      }
      if (newAddOns.notifications && !oldAddOns.notifications.enabled) {
        pushAddon('notifications', 'Notifications');
      }
      if (newAddOns.aiPhoneAgent && !oldAddOns.aiPhoneAgent.enabled) {
        pushAddon('aiPhoneAgent', 'AI Phone Agent');
      }
    } else {
      if (newAddOns.aiRouting) pushAddon('aiRouting', 'AI Routing');
      if (newAddOns.emailMarketing) pushAddon('emailMarketing', 'Email Marketing');
      if (newAddOns.notifications) pushAddon('notifications', 'Notifications');
      if (newAddOns.aiPhoneAgent) pushAddon('aiPhoneAgent', 'AI Phone Agent');
    }

    const total = packagePrice + trucksPrice + addonsPrice;

    this.priceBreakdown = {
      packagePrice,
      trucksPrice,
      addonsPrice,
      total: Number(total.toFixed(2))
    };
  }

  close(): void {
    this.dialogRef.close();
  }

  update(): void {
    // if (this.priceBreakdown.total <= 0) {
    //   this.toastr.error('Total amount should be greater than 0.');
    //   return;
    // }
    
    this.dialogRef.close({
      data: this.data,
      totalPrice: this.priceBreakdown.total
    });
  }

  abs(num: number, num2: number): any {
    if(num === num2) return ;
    const diff = num - num2;
    if(diff < 0) return 0;
    return diff;
  }
}
